import React, { useEffect, useState } from 'react';
import './style.scss';
import classNames from 'classnames';
import IconButton from '../IconButton';
import { useTranslation } from 'react-i18next';
import PendingOrdersInfoData from '../PendingOrdersInfoData';
import { createAction } from '../../../utils/sagaHelper';
import { ADMIN_ORDER_GET_ORDER_INFO_UNFINISHED_CART } from '../../../store/reducers/order/order-actions';
import { connect } from 'react-redux';
import { getDepotByBusinessId, getOrderMenuProducts } from '../../../services/restaurant';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { CUSTOMER_SERVICE_MODEL, ORDERING_MENU_TYPE_SECTION_MODEL } from '../../../utils/enums';
import AdminOrderInfoRestaurant from '../AdminOrderInfoRestaurant';
import AdminOrderInfoClientAndDelivery from '../AdminOrderInfoClientAndDelivery';
import { Spin } from 'antd';
import { REPEAT_ORDER } from '../../../store/reducers/editCustomerOrder/editCustomerOrder-action';

const UnfinishedCartPreview = ({ onClickBackButton, closeIcon, showBackButton, item, getOrderInfo, isLoading, onRepeatOrder }) => {
    const { t } = useTranslation();
    const history = useHistory();

    const [order, setOrder] = useState(null);
    const orderMenuProduct = getOrderMenuProducts(order);

    useEffect(() => {
        if (item) {
            getOrderInfo(item).then(data => setOrder(data));
        }
    }, [getOrderInfo, item]);

    const handleOnDepotClick = () => {
        return new Promise(resolve => {
            resolve();
            const depot = getDepotByBusinessId(order.business_id);
            history.push({
                pathname: ORDERING_MENU_TYPE_SECTION_MODEL.orderingBusinessMenu,
                search: `?id=${depot.id}&businessId=${(depot.business_id || depot.businessId)}`,
                state: {
                    pathFrom: CUSTOMER_SERVICE_MODEL.unfinishedCart,
                }
            });
        });
    }

    const handleOnSearchId = () => {
        if (order.customer_id) {
            history.push(CUSTOMER_SERVICE_MODEL.customers + "?userId=" + order.customer_id);
        }
    }

    const handleOnRepeat = () => {
        onRepeatOrder({ ...order, saveUserData: true });
        history.push("/create-order");
    }

    return (
        <div className={classNames('unfinishedCartContainer')}>
            <Spin spinning={isLoading} className="adminOrdersSpiner" />

            <div className='unfinishedCartTop'>
                {showBackButton && (
                    <IconButton isIcon iconName={'crossClose'} onClick={onClickBackButton} />
                )}
                {closeIcon && (
                    <IconButton isIcon iconName={'crossClose'} onClick={onClickBackButton} />
                )}
                <span>{t("admin-orders.ORDER_INFO_LABEL")}</span>
            </div>
            <div className='unfinishedCartContent'>
                {!!order && (
                    <>
                        <AdminOrderInfoRestaurant businessInfo={order.businessInfo || {}} handleOnDepotClick={handleOnDepotClick} />

                        {!!item.customer_id && (
                            <AdminOrderInfoClientAndDelivery hideDeliveryInfo order={order} handleOnSearchId={handleOnSearchId} />
                        )}

                        <div className={classNames("adminOrderInfoItem", "noMarginTop", "orderInfoProducts")}>
                            <div className={classNames("title")}>{t("admin-orders.ORDER_DETAILS_INFO_LABEL")}</div>
                            <div className={classNames("data", "full")}>
                                <PendingOrdersInfoData order={orderMenuProduct} item={orderMenuProduct} />
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className='unfinishedCartControls'>
                <div className='controls'>
                    <button
                        onClick={handleOnRepeat}
                        disabled={!item.customer_id}
                        className='btn confirm'>
                        {t("admin-orders.REPEAT")}
                    </button>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        isLoading: state.order?.data?.customTableConfigPagination?.unfinishedCart?.loadingPopup,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onRepeatOrder: data => dispatch(createAction(REPEAT_ORDER, data)),
        getOrderInfo: data => dispatch(createAction(ADMIN_ORDER_GET_ORDER_INFO_UNFINISHED_CART, data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UnfinishedCartPreview);